import { formatDate, isDefined } from '@/composables/utils'
import { TableStoreId } from '@/enums/TableStoreId'
import type { IEventsStore } from '@/interfaces/api/IEventsStore'
import type { ITableHeader } from '@/interfaces/ITableHeader'
import { TableStoreFactory } from '@/stores/db/TableStoreFactory'
import { type Composer } from 'vue-i18n'
import type { EventRecord } from '../EventRecord'

export const getTableHeaders = (
  i18n: Composer<{}, {}, {}, string, never, string>
): Array<ITableHeader> => {
  const eventsStore = TableStoreFactory.get(TableStoreId.Events) as IEventsStore
  return [
    {
      title: i18n.t('fields.events.category'),
      key: 'category',
      nowrap: true,
      align: 'start',
      value: (item: EventRecord) => {
        return eventsStore.getCategoryTitle(item.category)
      }
    },
    {
      title: i18n.t('fields.events.location'),
      key: 'location',
      align: 'start',
      headerProps: { searchField: true }
    },
    {
      title: i18n.t('fields.events.organizer'),
      key: 'organizerId',
      align: 'start',
      value: (item: EventRecord) => {
        return `${item.organizerLastName}, ${item.organizerFirstName}`
      }
    },
    {
      title: i18n.t('fields.events.dtStart'),
      key: 'dtStart',
      nowrap: true,
      align: 'start',
      value: (item: EventRecord) => {
        return isDefined(item.dtStart) ? formatDate(item.dtStart, true) : '-'
      }
    },
    {
      title: i18n.t('fields.actions'),
      key: 'actions',
      align: 'start',
      nowrap: true,
      sortable: false
    }
  ]
}
